const n = (e) => {
  throw new Error(`Unexpected object: ${e}`);
}, a = (e, r) => {
  try {
    return n(e);
  } catch (t) {
    return console.warn(t), r;
  }
};
export {
  n as assertUnreachable,
  a as assertUnreachableWithDefault
};
